/*
** nopCommerce custom js functions
*/


function getE(name) {
    //Obsolete since nopCommerce 2.60. But still here for backwards compatibility (in case of some plugin developers used it in their plugins or customized solutions)
    if (document.getElementById)
        var elem = document.getElementById(name);
    else if (document.all)
        var elem = document.all[name];
    else if (document.layers)
        var elem = document.layers[name];
    return elem;
}

function OpenWindow(query, w, h, scroll) {
    var l = (screen.width - w) / 2;
    var t = (screen.height - h) / 2;

    var winprops = 'resizable=0, height=' + h + ',width=' + w + ',top=' + t + ',left=' + l + 'w';
    if (scroll) winprops += ',scrollbars=1';
    var f = window.open(query, "_blank", winprops);
}

function setLocation(url) {
    window.location.href = url;
}

String.prototype.startsWith = function(prefix) {
    return this.indexOf(prefix) == 0;
};

String.prototype.endsWith = function(suffix) {
    var index = this.indexOf(suffix);
    return index >= 0 && this.length == index + suffix.length;
};

Location.prototype.query = function(q) {
    var href = window.location.href;
    var parts = href.split('?');
    if (q) {
        //console.log('push state', q);
        window.history.pushState({data: q}, "", [parts[0], q].join('?'));
        return q;
    } 
    if (parts.length == 2) {
        return parts[1];
    }
    return null;
};
